const columns = {
    "timeframes-list": [
        {
            name: "Symbol", 
            field: "symbol", 
            sortable: true, 
            order: 0
        }, 
        {
            name: "Name",
            field: "name",
            order: 1
        },
        {
            name: "Industry Group", 
            field: "industry_group",
            order: 2
        },
        {
            name: "Reversal Scout", 
            field: "reversal_scout", 
            sortable: true, 
            order: 3
        }, 
        {
            name: "Slim Ribbon", 
            field: "slim_ribbon", 
            sortable: true, 
            order: 4
        }
    ], 
    "traders-list": [
        {
            name: "Symbol", 
            field: "symbol", 
            sortable: true, 
            order: 0
        },
        {
            name: "Name",
            field: "name",
            order: 1
        },
        {
            name: "Industry Group", 
            field: "industry_group",
            order: 2
        }, 
        {
            name: "Reversal Scout", 
            field: "reversal_scout", 
            sortable: true, 
            order: 3
        }, 
        {
            name: "Slim Ribbon", 
            field: "slim_ribbon", 
            sortable: true, 
            order: 4
        }, 
        {
            name: "Trade Set-Up Condition", 
            field: "trade_setup_condition", 
            sortable: true, 
            order: 5
        },
        {
            name: "Alerts",
            field: "notify_setup_condition",
            sortable: true,
            order: 6
        }
    ], 
    "all": [
        {
            name: "Timeframe", 
            field: "timeframe", 
            sortable: true, 
            order: 0
        }, 
        {
            name: "Reversal Scout", 
            field: "reversal_scout", 
            sortable: true, 
            order: 1
        }, 
        {
            name: "Slim Ribbon", 
            field: "slim_ribbon", 
            sortable: true, 
            order: 2
        }
    ], 
    "intraday": [
        {
            name: "Indicator", 
            field: "indicator", 
            sortable: true, 
            order: 0
        }, 
        {
            name: "Two Hour", 
            field: "two_hour", 
            sortable: true, 
            order: 1
        },
        {
            name: "Fifteen Minute", 
            field: "fifteen_minute", 
            sortable: true, 
            order: 2
        }, 
        {
            name: "Three Minute", 
            field: "three_minute", 
            sortable: true, 
            order: 3
        }
    ],
    "near_term": [
        {
            name: "Indicator", 
            field: "indicator", 
            sortable: true, 
            order: 0
        }, 
        {
            name: "Daily", 
            field: "daily", 
            sortable: true, 
            order: 1
        },
        {
            name: "Two Hour", 
            field: "two_hour", 
            sortable: true, 
            order: 2
        }, 
        {
            name: "Fifteen Minute", 
            field: "fifteen_minute", 
            sortable: true, 
            order: 3
        }
    ], 
    "short_term": [
        {
            name: "Indicator", 
            field: "indicator", 
            sortable: true, 
            order: 0
        }, 
        {
            name: "Weekly", 
            field: "weekly", 
            sortable: true, 
            order: 1
        },
        {
            name: "Daily", 
            field: "daily", 
            sortable: true, 
            order: 2
        }, 
        {
            name: "Two Hour", 
            field: "two_hour", 
            sortable: true, 
            order: 3
        }

    ], 
    "intermediate": [
        {
            name: "Indicator", 
            field: "indicator", 
            sortable: true, 
            order: 0
        }, 
        {
            name: "Monthly", 
            field: "monthly", 
            sortable: true, 
            order: 1
        },
        {
            name: "Weekly", 
            field: "weekly", 
            sortable: true, 
            order: 2
        }, 
        {
            name: "Daily", 
            field: "daily", 
            sortable: true, 
            order: 3
        }
    ]
}

export default columns;